export const META_CONVERTS_BRANDS = {
  KIEHLS: 'KIEHLS',
  LANCOME: 'LANCOME',
} as const;
